export default __webpack_public_path__ + "static/media/hht2_home_img_EP6.66f56a19.png";